<template>
  <div class="search-component">
    <ExtraBtnSquare
      v-for="contract in activeContracts"
      :key="contract.getName()"
      :icon="`fad ${contract.getIcon()}`"
      :label="contract.getLabel()"
      @click.once="$emit('onClickAction', contract)"
    />
  </div>
</template>
<script>
  export default {
    props: {
      activeContracts: {
        type: Array,
        default: () => [],
      },
    },
    emits: ["onClickAction"],
  };
</script>
<style lang="scss">
  .search-component {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    button {
      flex: 0 0 140px;
      margin: 10px;

      @media screen and (max-width: 320px) {
        margin: 5px;
      }
    }
  }
</style>
